<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
          }}</span>
        <span class="masge">当前共有{{ total }}条{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button  class="btn primary" type="primary" size="small"
            v-preventReClick @click="uploadEvt">上传</el-button>

            <el-button  class="btn primary" type="primary" size="small"
            v-preventReClick @click="getSettlement">获取结算</el-button>

        
        </div>
        <div class="right">
          <div class="search">
            <!-- <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input> -->
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>

      <el-table ref="multipleTable" border row-key="id" v-loading="loading" :data="tableData" :max-height="tableHeight"
        style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
        </el-table-column>
        <el-table-column width="180" prop="categoryName" label="计费类型"></el-table-column>
        <el-table-column width="180" prop="supplierProductNo" label="供应商产品编码"></el-table-column>
        <el-table-column width="180" prop="productName" label="供应商产品名称"></el-table-column>
        <el-table-column width="180" prop="mainNo" label="主条码"></el-table-column>
        <el-table-column width="130" prop="traceNo" label="追溯码"></el-table-column>
        <el-table-column width="120" prop="batch" label="批次号">
          <template slot-scope="scope">
            {{ scope.row.batch?scope.row.batch:'-' }}
          </template>
        </el-table-column>
        <el-table-column width="120" prop="productNo" label="产品编码"></el-table-column>
        <el-table-column width="170" prop="manufactureDate" label="生产日期">
          <template slot-scope="scope">
            {{ scope.row.manufactureDate?parseTime(new Date(scope.row.manufactureDate), "{y}-{m}-{d} "):'-' }}
          </template>
        </el-table-column>
        <el-table-column width="170" prop="validityDate" label="有效期">
          <template slot-scope="scope">
            {{ scope.row.validityDate?parseTime(new Date(scope.row.validityDate), "{y}-{m}-{d} "):'-' }}
          </template>
        </el-table-column>
        <el-table-column width="120" prop="price" label="计费价"></el-table-column>
        <el-table-column width="120" prop="number" label="数量"></el-table-column> 
        <el-table-column width="120" prop="chargeNo" label="计费单号"></el-table-column> 
        <el-table-column width="120" prop="chargeDeptName" label="计费科室"></el-table-column> 
        <el-table-column width="120" prop="deptName" label="执行科室"></el-table-column> 
        <el-table-column width="170" prop="effectiveTime" label="计费时间">
          <template slot-scope="scope">
            {{ parseTime(new Date(scope.row.effectiveTime), "{y}-{m}-{d} ") }}
          </template>
        </el-table-column>
        <el-table-column width="120" prop="createdUserName" label="计费人"></el-table-column> 
        <el-table-column width="120" prop="hisSerialNumber" label="就医流水号">
          <template slot-scope="scope">
            {{ scope.row.hisSerialNumber?scope.row.hisSerialNumber:'-' }}
          </template>
        </el-table-column>  
        <el-table-column width="120" prop="hisSetlType" label="结算类型">
          <template slot-scope="scope">
            {{ scope.row.hisSetlType?scope.row.hisSetlType:'-' }}
          </template>
        </el-table-column>  
        <el-table-column width="120" prop="patientName" label="患者姓名"></el-table-column>  
        <el-table-column width="120" prop="patientNo" label="住院号/门诊号"></el-table-column> 
        <el-table-column width="120" prop="leaveHospital" label="出院标识"></el-table-column> 
        <el-table-column width="120" prop="medicalInsuranceCategoryNo" label="医保代码"></el-table-column>
        <el-table-column width="120" prop="stateName" label="上传状态"></el-table-column>
        <el-table-column width="120" show-overflow-tooltip prop="errMessage" label="失败原因">
          <template slot-scope="scope">
            {{ scope.row.errMessage?scope.row.errMessage:'-' }}
          </template>
        </el-table-column>
        <el-table-column width="120" prop="failureNumber" label="失败次数"></el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange"
        :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { GetChangeSaleUploads, PushChangeSaleReturnToUdi,GetHisSetlType } from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import { ChargeCategoryOptions, ApproveStatusOptions } from "@/enum";
import SelectFilter from "@/components/table-select-filter";
import BaseListMixin from "@/mixin/baseList-mixin.js";

export default {
  mixins: [GetDataMixin, GetDataSpdMixin, BaseListMixin],
  components: {
    SelectFilter,
  },
  data () {
    return {
      GetDatasAction: GetChangeSaleUploads,
      // PrintAction: GetAcceptInStockPrintData,
      // editPath: "surgical-use-edit",

      ChargeCategoryOptions: ChargeCategoryOptions,
      ApproveStatusOptions: ApproveStatusOptions,

    };
  },
  methods: {
    getData(){
      this.query.categorys = [1]
      this.GetDatasAction(this.query).then((res) => {
        this.tableData = res.returnData.data;
        this.total = res.returnData.totalCount;
      })
    },
    uploadEvt(){
           if(this.multipleSelection==0){
        this.$my_message("请勾选数据", "warning");
        return
      }
      let ids =  this.multipleSelection.map(res=>res.id)
      PushChangeSaleReturnToUdi({ids}).then(res=>{
        if(res.successful){
          this.$my_message('操作成功', "success");
          this.getData()
        }
      })
    },
    getSettlement(){
      if(this.multipleSelection==0){
        this.$my_message("请勾选数据", "warning");
        return
      }
     let arr =  this.multipleSelection.filter(res=>res.leaveHospital=='是')
      if(arr.length==0){
        this.$my_message("请勾选出院标识为”是“且结算类型和就医流水号为空的数据", "warning");
        return
      }
      let ids =  this.multipleSelection.map(res=>res.id)
      GetHisSetlType({ids}).then(res=>{
        if(res.successful){
          if(res.errorMessage){
            this.$my_message(res.errorMessage, "success");
          }
          this.getData()
        }
      })
    },
  },
  mounted () {
  

   },
};
</script>

<style lang="scss" scoped></style>
